import PropTypes from "prop-types";

// @mui material components
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

/**
 * Select field built on MDInput (outlined TextField) for MUI v5 forms.
 * `options` are { value, label } objects; `placeholder` adds a first item
 * without value (disabled unless `placeholderSelectable` is set).
 * onChange receives (event, child) like the MUI Select.
 */
export default function FormSelect({
	label,
	value,
	onChange,
	options = [],
	placeholder,
	placeholderSelectable = false,
	error,
	helperText,
	disabled,
	required,
	sx,
	children
}) {
	return (
		<MDInput
			select
			fullWidth
			label={label}
			value={value ?? ""}
			onChange={onChange}
			error={!!error}
			helperText={helperText}
			disabled={disabled}
			required={required}
			sx={{
				// The MD3 theme removes the vertical padding of selects (and hides
				// their arrow): restore the same 12px padding as the other inputs
				"& .MuiSelect-select.MuiSelect-select.MuiInputBase-input": {
					padding: "12px 32px 12px 12px !important",
					minHeight: "1.4375em !important",
					display: "flex",
					alignItems: "center"
				},
				"& .MuiSelect-icon": {
					display: "inline-block",
					right: "8px"
				},
				...sx
			}}
		>
			{placeholder && (
				<MenuItem disabled={!placeholderSelectable}>{placeholder}</MenuItem>
			)}
			{children ||
				options.map(option => (
					<MenuItem key={option.value} value={option.value}>
						{option.label}
					</MenuItem>
				))}
		</MDInput>
	);
}

FormSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.any,
	onChange: PropTypes.func.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({ value: PropTypes.any, label: PropTypes.node })
	),
	placeholder: PropTypes.string,
	placeholderSelectable: PropTypes.bool,
	error: PropTypes.bool,
	helperText: PropTypes.node,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	sx: PropTypes.object,
	children: PropTypes.node
};
